import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { User } from '@/lib/data';

interface ImpersonationState {
  isImpersonating: boolean;
  impersonatedUser: User | null;
  adminUser: User | null;
  adminToken: string | null;
  startImpersonation: (impersonatedUser: User, adminUser: User, adminToken: string) => void;
  stopImpersonation: () => void;
}

export const useImpersonationStore = create<ImpersonationState>()(
  devtools(
    (set) => ({
      isImpersonating: false,
      impersonatedUser: null,
      adminUser: null,
      adminToken: null,
      startImpersonation: (impersonatedUser, adminUser, adminToken) =>
        set(
          { isImpersonating: true, impersonatedUser, adminUser, adminToken },
          false,
          'startImpersonation',
        ),
      stopImpersonation: () =>
        set(
          {
            isImpersonating: false,
            impersonatedUser: null,
            adminUser: null,
            adminToken: null,
          },
          false,
          'stopImpersonation',
        ),
    }),
    { name: 'impersonation-store' },
  ),
);
